import { Box, Button, Stack, Card, Checkbox, Chip, FormControl, FormControlLabel, FormHelperText, Grid, InputAdornment, InputLabel, MenuItem, Modal, OutlinedInput, Select, TextField, Typography, IconButton, Tooltip } from "@mui/material";
import { zodResolver } from "@hookform/resolvers/zod";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import showToast from "../../../components/Hot-Toast/showToast";
import { customStep, nextStep, update } from "../../../slice/jobSlice";
import { useTMutation } from "../../../utils/useTMutation";
import AddJobType from "./addJobType";
import { OneTimeSchema, RecusrringSchema } from "../../../hooks/validationSchema";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import { ChipRowTime, ChipRowTime2 } from "../../../components/ChipsRows/ChipRow";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useCallback, useEffect, useMemo, useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useTQuery } from "../../../utils/useTQuery";
import { generateJobDatesWeekly } from "../../../utils/genericMethod";
import JobDatesPopup from "../../../components/DialogPopup/JobDatesPopup";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  boxShadow: 24,
  p: 4,
  display: 'grid',
  justifyContent: 'center',
  // height: "200px",
  // overflowY: "auto",
  maxHeight: "80vh", overflowY: "auto"
};
const list = [{ id: "Weekly", label: "Weekly", status: "Active" },]
const weeklist = [{ id: "Monday", label: "Mon" }, { id: "Tuesday", label: "Tue" }, { id: "Wednesday", label: "Wed" }, { id: "Thursday", label: "Thu" }, { id: "Friday", label: "Fri" }, { id: "Saturday", label: "Sat" }, { id: "Sunday", label: "Sun" }]
const columns = [
  { field: "jobDate", headerName: "Job Date", flex: 1 },
  { field: "startTime", headerName: "Start Time", flex: 1 },
  { field: "endTime", headerName: "End Time", flex: 1 },
];

const AddJobPrice = () => {
  const today = new Date();
  const nextDay = new Date(today.getTime() + 24 * 60 * 60 * 1000);
  const { mutateAsync } = useTMutation("/job/addUpdateJob", "post", (data) => {
    return data;
  });
  const [openModal1, setOpenModal1] = useState(false);

  const { jobData, step } = useSelector((state) => state.job);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const correctOrder = useMemo(
    () => [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ],
    []
  );
    const [documentNames, setDocumentNames] = useState(jobData?.documentNames || []);
      const [isRequired, setIsRequired] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [openJobDatesTable, setJobDatesTable] = useState(false);
  const [jobStartTime, setJobStartTime] = useState(null);
  const [jobEndTime, setJobEndTime] = useState(null);
  const [jobDates, setJobDates] = useState([]);
  const [selectedInTime, setSelectedInTime] = useState("09:00"); // To track the selected JOB_IN_TIME
  const [selectedOutTime, setSelectedOutTime] = useState("18:00"); // To track the selected JOB_OUT_TIME
  const validatorSchema =
    jobData.SERVICE_TYPE === "Recurring" ? RecusrringSchema : OneTimeSchema;

 const handleAdd = () => {
    if (
      inputValue.trim() !== "" &&
      !documentNames.some((doc) => doc.DOCUMENT_NAME === inputValue.trim())
    ) {
      const newDoc = {
        DOCUMENT_NAME: inputValue.trim(),
        ...(isRequired && { IS_REQUIRED: true }) // only add if true
      };

      setDocumentNames([...documentNames, newDoc]);
      setInputValue("");
      setIsRequired(false);
    }
  };

  const handleDelete = (docName) => {
    setDocumentNames(documentNames.filter((d) => d.DOCUMENT_NAME !== docName));
  };

  const handleShowJobDates = () => {
    setJobDatesTable(true);
  };

  // Function to Close Modal
  const handleCloseJobDates = () => {
    setJobDatesTable(false);
  };

  const { data } = useTQuery(
    ["users"],
    `/facilityLocation?${new URLSearchParams({
      USER_ID: jobData?.USER_ID,
    }).toString()}`,
    "get"
  );

  // Fetch existing required documents when editing a saved job
  const { data: fetchedJobDocuments } = useTQuery(
    ["jobDocuments", jobData?.ID],
    jobData?.MODE === "Edit" && jobData?.ID
      ? `job/fetchMiscellaneousDocumentsByJobId?${new URLSearchParams({ jobId: jobData.ID }).toString()}`
      : null,
    "get",
    {},
    jobData?.MODE === "Edit" && !!jobData?.ID
  );

  useEffect(() => {
    if (fetchedJobDocuments?.OUTPUT?.length > 0 && documentNames.length === 0) {
      const mapped = fetchedJobDocuments.OUTPUT.map((doc) => ({
        DOCUMENT_NAME: doc.DOCUMENT_NAME,
        ...(doc.IS_REQUIRED && { IS_REQUIRED: true }),
      }));
      setDocumentNames(mapped);
    }
  }, [fetchedJobDocuments]);

  const showJobTypeSection = jobData?.JOB_TYPE === "PER DIEM WORK";
  const [locationData, setLocationData] = useState();
  // console.log("setLocationData",locationData)

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    watch,
    setValue,
    clearErrors,
  } = useForm({
    resolver: zodResolver(validatorSchema),
    defaultValues: {
      SERVICE_TYPE: jobData.SERVICE_TYPE || "Recurring",
      // JOB_SERVICE_WITH_DAY_TIME: jobData.JOB_SERVICE_WITH_DAY_TIME || [],
      SERVICE_DATE: jobData.SERVICE_DATE
        ? new Date(jobData.SERVICE_DATE)
        : null,
      SERVICE_END_DATE: jobData.SERVICE_END_DATE
        ? new Date(jobData.SERVICE_END_DATE)
        : null,
      JOB_NAME: jobData.JOB_NAME || "",
      JOB_IN_TIME: jobData.JOB_IN_TIME || "09:00",
      JOB_OUT_TIME: jobData.JOB_OUT_TIME || "18:00",
      JOB_START_TIME: jobData.JOB_START_TIME || "",
      JOB_END_TIME: jobData.JOB_END_TIME || "",
      JOB_SITE_ADDRESS: jobData.JOB_SITE_ADDRESS || "",
      JOB_SERVICE_DURATION: jobData.JOB_SERVICE_DURATION || "Weekly",
      PAY_AMOUNT_FROM: jobData.PAY_AMOUNT_FROM || "",
      PAY_AMOUNT_TO: jobData.PAY_AMOUNT_TO || "",
      FACILITY_LOCATION: locationData || undefined,
      REQUIRED_APPLICANTS: jobData.REQUIRED_APPLICANTS || "1",
    },
  });

  const [generateJobDates, setGeneratedJobDates] = useState(false);
  //

  const [time, setTime] = useState(() => {
    const initial = jobData?.JOB_SERVICE_WITH_DAY_TIME || [];
    return [...initial].sort(
      (a, b) =>
        correctOrder.indexOf(a.JOB_DAY) - correctOrder.indexOf(b.JOB_DAY)
    );
  });

  useEffect(() => {
    if (jobData?.SERVICE_TYPE === "Recurring") {
      setValue("JOB_SERVICE_WITH_DAY_TIME", time);
    }
  }, [time, jobData?.SERVICE_TYPE]);

  const startDate = useMemo(
    () => new Date(watch("SERVICE_DATE")),
    [watch("SERVICE_DATE")]
  );
  const endDate = useMemo(
    () => new Date(watch("SERVICE_END_DATE")),
    [watch("SERVICE_END_DATE")]
  );

  const selectedDaysTime = watch("JOB_SERVICE_WITH_DAY_TIME");

  useEffect(() => {
    if (jobData?.FACILITY_LOCATION) {
      setLocationData(jobData.FACILITY_LOCATION);
    } else if (data?.OUTPUT?.length > 0) {
      setLocationData(data.OUTPUT[0]); // Set first location as default if available
    }
  }, [jobData, data]);
  // useEffect(() => {
  //   if (time.length > 0 && startDate && endDate) {
  //     getJobDate(startDate, endDate, selectedDaysTime);
  //   } else {
  //     setJobDates([]);
  //   }
  // }, [time, startDate, endDate, selectedDaysTime]);
  const getJobDate = async (startDate, endDate, selectedDaysTime) => {
    // console.log("JobDate", startDate, endDate, selectedDaysTime);
    const JobDateResult = await generateJobDatesWeekly(
      startDate,
      endDate,
      selectedDaysTime
    );
    const flattenedResult = [].concat(...JobDateResult);
    console.log("JobDateResult", flattenedResult);
    setJobDates(JobDateResult);
  };
  useEffect(() => {
    if (jobData?.JOB_TYPE !== "PER DIEM WORK") {
      setValue("SERVICE_TYPE", "Recurring");
      dispatch(update({ SERVICE_TYPE: "Recurring" }));
      // dispatch(update({ JOB_SERVICE_WITH_DAY_TIME: [] }));
    } else {
      setValue("SERVICE_TYPE", "One Time");
      dispatch(update({ SERVICE_TYPE: "One Time" }));
    }
  }, [dispatch, jobData?.JOB_TYPE]);

  const handleClick = useCallback(
    (chipId) => {
      setTime((prevSelectedChips) => {
        const updatedSelectedChips = new Set(prevSelectedChips);
        const chipToDelete = [...updatedSelectedChips].find(
          (val) => val.JOB_DAY === chipId
        );
        if (chipToDelete) {
          updatedSelectedChips.delete(chipToDelete);
        } else {
          updatedSelectedChips.add({
            JOB_ID: jobData?.ID,
            JOB_IN_TIME: "",
            JOB_OUT_TIME: "",
            JOB_DAY: chipId,
          });
        }
        const sortedDays = [...updatedSelectedChips].sort((a, b) => {
          return (
            correctOrder.indexOf(a.JOB_DAY) - correctOrder.indexOf(b.JOB_DAY)
          );
        });

        return sortedDays;
      });
    },
    [correctOrder, jobData?.ID]
  );

  const handleSaveTime = () => {
    // setTime((prevTime) => {
    //   const updatedTime = [...prevTime];
    //   const updatedEntry = {
    //     ...updatedTime[openModal.index],
    //     JOB_IN_TIME: selectedInTime,
    //     JOB_OUT_TIME: selectedOutTime,
    //   };
    //   updatedTime[openModal.index] = updatedEntry;

    //   return updatedTime;
    // });
    setOpenModal(false);
  };

  const handleChange = (event) => {
    setGeneratedJobDates(event.target.checked);
  };

  const onSubmitNext = async (data) => {
    console.log("data submit", data);
data.documentNames = documentNames;
    if (jobData.SERVICE_TYPE === "Recurring") {
      data.JOB_SERVICE_WITH_DAY_TIME = time;
      data.jobDates = jobDates;
      data.generateJobDates = generateJobDates;
      const { SERVICE_DATE, SERVICE_END_DATE } = data;
      if (!SERVICE_DATE || !SERVICE_END_DATE) {
        setError("SERVICE_END_DATE", {
          type: "manual",
          message: "Both start and end dates are required.",
        });
        return;
      }
      if (!dayjs(SERVICE_END_DATE).isAfter(dayjs(SERVICE_DATE))) {
        setError("SERVICE_END_DATE", {
          type: "manual",
          message: "End date must be after the start date (and not equal).",
        });
        return;
      }
      if (!SERVICE_DATE || !SERVICE_END_DATE) {
        setError("SERVICE_END_DATE", {
          type: "manual",
          message: "Both start and end dates are required.",
        });
        return;
      }
      // if (!jobDates || jobDates.length === 0) {
      //   setError("JOB_SERVICE_WITH_DAY_TIME", {
      //     type: "manual",
      //     message: "Check Job Dates before proceeding.",
      //   });
      //   showToast("error", "Check Job Dates before proceeding.");
      //   return;
      // }
      // if (!data.jobDates || data.jobDates.length === 0 ) {
      //     showToast("error", "Job Start Date, Job End Date, and Schedule Please check before proceeding. Something Error");
      //     return;
      // }
    }
    if (!locationData?.ID) {
      showToast("error", "Location is required");
      return;
    }

    data.FACILITY_LOCATION = {
      FACILITY_NAME: locationData?.FACILITY_NAME,
      ID: locationData?.ID,
      STREET_ADDRESS: locationData?.STREET_ADDRESS,
    };
    data.LOCATION_ID = locationData?.ID;
    data.SERVICE_TYPE = jobData.SERVICE_TYPE;
    console.log("Submit data", data);
    // return;
    try {
      const response = await mutateAsync({
        ...data,
        STEP: jobData.REDIRECT ? 8 : step + 1,
        ID: jobData.ID,
      });
      console.log("response", response);
      if (response.STATUS) {
        setGeneratedJobDates(false);
        // console.log("after data", data);
        dispatch(update({ ...data, REDIRECT: false }));
        dispatch(
          update({ GENERATE_JOB_DATES: response.OUTPUT.GENERATE_JOB_DATES })
        );
        if (jobData.REDIRECT) {
          dispatch(customStep(8));
          dispatch(
            update({
              FACILITY_LOCATION: {
                FACILITY_NAME: locationData?.FACILITY_NAME,
                ID: locationData?.ID,
                STREET_ADDRESS: locationData?.STREET_ADDRESS,
              },
            })
          );
        } else {
          dispatch(nextStep());
        }
        // dispatch(update({ ...data, "REDIRECT": false }));
        // dispatch(update({ "GENERATE_JOB_DATES": response.OUTPUT.GENERATE_JOB_DATES }));
      } else {
        showToast("error", data.MESSAGE, 3000);
      }
    } catch (error) {
      console.error("Validation Request failed:", error.message);
      // showToast("error", "Something went wrong, Please try again", 3000);
    }
  };

  useEffect(() => {
    console.log("errors", errors);
  }, [errors]);
  return (
    <>
      <form onSubmit={handleSubmit(onSubmitNext)}>
        <Grid
          container
          alignItems="center"
          spacing={1}
          justifyContent="space-around"
          px={3}
          pb={3}
        >
          {/* <Grid
            container
            alignItems="center"
            spacing={1}
            justifyContent="space-around"
            px={3}
            pb={3}
          > */}
            {jobData.SERVICE_TYPE === "One Time" ? (
              <Grid item xs={12} sm={12}>
                <Typography variant="h3" className="about-texts">
                  When do you need the service?
                </Typography>
              </Grid>
            ) : (
              <Grid item xs={12} sm={12}>
                <Typography variant="h4" mt={2}>
                  When does this job start?
                </Typography>
              </Grid>
            )}

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Grid item lg={12} xs={12}>
                  <FormControl fullWidth>
                    <DatePicker
                    label="Date"
                    placeholder="Date"
                    defaultValue={null}
                    minDate={jobData.MODE !== "Edit" ? dayjs(today) : undefined}
                    disabled={
                      !generateJobDates && jobData?.GENERATE_JOB_DATES === 1
                    }
                    value={
                      watch("SERVICE_DATE") &&
                        dayjs(watch("SERVICE_DATE")).isValid()
                        ? dayjs(watch("SERVICE_DATE"))
                        : null
                    }
                    onChange={(date) => {
                      setValue("SERVICE_DATE", date ? date.toDate() : null); // Use null instead of invalid Date
                      if (errors.SERVICE_DATE) clearErrors("SERVICE_DATE"); // Clear error if set
                    }}
                    renderInput={(params) => (
                      <TextField {...params} fullWidth />
                    )}
                    slotProps={{
                      textField: {
                        error: !!errors.SERVICE_DATE, // Simplified error handling
                      },
                    }}
                    
                  />
                  </FormControl>
                  

                  {errors?.SERVICE_DATE && (
                    <FormHelperText error>
                      {errors.SERVICE_DATE?.message}
                    </FormHelperText>
                  )}
                </Grid>
              </LocalizationProvider>

            {/* When do you need the service? */}
            {showJobTypeSection && <AddJobType />}
            {jobData.SERVICE_TYPE === "Recurring" && (
              <>
                <Grid item xs={12} sm={12}>
                  <Typography variant="h4" mt={2}>
                    When does this job end?
                  </Typography>
                </Grid>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Grid item lg={12} xs={12}>
                      <FormControl fullWidth>
                         <DatePicker
                        label="Date"
                        placeholder="Date"
                        defaultValue={null}
                        disabled={
                          !generateJobDates && jobData?.GENERATE_JOB_DATES === 1
                        }
                        value={
                          watch("SERVICE_END_DATE")
                            ? dayjs(watch("SERVICE_END_DATE")).isValid()
                              ? dayjs(watch("SERVICE_END_DATE"))
                              : null
                            : null
                        }
                        onChange={(date) => {
                          setValue(
                            "SERVICE_END_DATE",
                            date ? date.toDate() : null
                          ); // Use null instead of invalid Date
                          if (errors.SERVICE_END_DATE)
                            clearErrors("SERVICE_END_DATE"); // Clear error if set
                        }}
                        minDate={jobData.MODE !== "Edit" ? dayjs(nextDay) : undefined}
                        renderInput={(params) => (
                          <TextField {...params} fullWidth />
                        )}
                        slotProps={{
                          textField: {
                            error: !!errors.SERVICE_END_DATE, // Simplified error handling
                          },
                        }}
                      
                      />
                      </FormControl>
                     

                      {errors?.SERVICE_END_DATE && (
                        <FormHelperText error>
                          {errors.SERVICE_END_DATE?.message}
                        </FormHelperText>
                      )}
                    </Grid>
                  </LocalizationProvider>
              </>
            )}

            <Grid item xs={12} sm={12}>
              <Typography variant="h4" mt={2}>
                Job Name
              </Typography>
            </Grid>
            <Grid item lg={12} xs={12}>
              
 <FormControl fullWidth>
  <OutlinedInput
                placeholder="Enter Job Name"
                fullWidth
                value={watch("JOB_NAME") || ""}
                onChange={(e) => {
                  setValue("JOB_NAME", e.target.value);
                  if (errors.JOB_NAME) clearErrors("JOB_NAME");
                }}
                error={!!errors.JOB_NAME}
                helperText={errors.JOB_NAME?.message || ""}
               
              />
 </FormControl>

              
            </Grid>
 
            <Grid item xs={12} sm={12}>
              <Typography variant="h4" mt={2} sx={{ fontWeight: 500 }}>
                {/* What range would you like to pay for this job? */}
                Set the time for this job
              </Typography>
            </Grid>

            {/* <Grid item xs={6} sm={6}>
              <FormControl fullWidth error={!!errors?.PAY_AMOUNT_FROM}>
                <InputLabel htmlFor="outlined-adornment-amount">
                  From
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-amount"
                  startAdornment={
                    <InputAdornment position="start">$</InputAdornment>
                  }
                  label="From"
                  {...register("PAY_AMOUNT_FROM")}
                  value={watch("PAY_AMOUNT_FROM") || ""}
                  error={!!errors?.PAY_AMOUNT_FROM}
                  helperText={errors?.PAY_AMOUNT_FROM?.message}
                />
              </FormControl>
              {errors.PAY_AMOUNT_FROM && (
                <Typography color="error" variant="body2" mt={1}>
                  {errors.PAY_AMOUNT_FROM.message}
                </Typography>
              )}
            </Grid>
            <Grid item xs={6} sm={6}>
              <FormControl fullWidth error={!!errors?.PAY_AMOUNT_TO}>
                <InputLabel htmlFor="outlined-adornment-amount">To</InputLabel>
                <OutlinedInput
                  id="outlined-adornment-amount"
                  startAdornment={
                    <InputAdornment position="start">$</InputAdornment>
                  }
                  label="To"
                  {...register("PAY_AMOUNT_TO")}
                  value={watch("PAY_AMOUNT_TO") || ""}
                />
              </FormControl>
              {errors.PAY_AMOUNT_TO && (
                <Typography color="error" variant="body2" mt={1}>
                  {errors.PAY_AMOUNT_TO.message}
                </Typography>
              )}
            </Grid> */}

          <LocalizationProvider dateAdapter={AdapterDayjs}>
  {/* JOB START TIME */}
  <Grid item xs={12} sm={6}>
    <MobileTimePicker
      label="Job Start Time"
      value={
        watch("JOB_START_TIME")
          ? dayjs(watch("JOB_START_TIME"), "HH:mm A")
          : null
      }
      onChange={(value) => {
        const timeString = value ? value.format("HH:mm A") : "";
        setValue("JOB_START_TIME", timeString);
        if (errors.JOB_START_TIME) clearErrors("JOB_START_TIME");
      }}
      slotProps={{
        textField: {
          placeholder: "",
                InputLabelProps: { shrink: true }, // forces label to stay outside
          fullWidth: true,
          error: !!errors.JOB_START_TIME,
          helperText: errors.JOB_START_TIME?.message || "",
          sx: {
            "& .MuiInputBase-input": {
              padding: 1.814,
            },
          },
        },
      }}
    />
  </Grid>

  {/* JOB END TIME */}
  <Grid item xs={12} sm={6}>
    <MobileTimePicker
      label="Job End Time"
      value={
        watch("JOB_END_TIME")
          ? dayjs(watch("JOB_END_TIME"), "HH:mm A")
          : null
      }
      onChange={(value) => {
        const timeString = value ? value.format("HH:mm A") : "";
        setValue("JOB_END_TIME", timeString);
        if (errors.JOB_END_TIME) clearErrors("JOB_END_TIME");
      }}
      slotProps={{
        textField: {
                InputLabelProps: { shrink: true }, // forces label to stay outside
          placeholder: "",
          fullWidth: true,
          error: !!errors.JOB_END_TIME,
          helperText: errors.JOB_END_TIME?.message || "",
          sx: {
            "& .MuiInputBase-input": {
              padding: 1.814,
            },
          },
        },
      }}
    />
  </Grid>
</LocalizationProvider>




            <Grid item xs={12} sm={12}>
              <Typography variant="h4" mt={2}>
                Job Site Address
              </Typography>
            </Grid>
                    
            <Grid item
        xs={12}
        sm={12}
        display="flex"
        flexDirection="column"
        gap={1}
        >

                      <FormControl fullWidth>
                        
                         <OutlinedInput
    id="job-site-address"
    placeholder="Enter Job Site Address"
    value={watch("JOB_SITE_ADDRESS") || ""}
    onChange={(e) => {
      setValue("JOB_SITE_ADDRESS", e.target.value);
      if (errors.JOB_SITE_ADDRESS) clearErrors("JOB_SITE_ADDRESS");
    }}
    error={!!errors.JOB_SITE_ADDRESS}
  />
                         </FormControl>

                 
            </Grid>


            {jobData?.SERVICE_TYPE === "One Time" ? (
              <>
                <Grid item xs={12} sm={12}>
                  <Typography variant="h4" mt={2}>
                    Shift Timing
                  </Typography>
                </Grid>

                <Grid container spacing={2} mt={-0.5}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Grid item xs={6}>
                      <DemoContainer components={["TimePicker"]}>
                        <MobileTimePicker
                          label="From"
                          // value={dayjs(`2022-04-17T${selectedInTime}`)}
                          value={
                            watch("JOB_IN_TIME")
                              ? dayjs(watch("JOB_IN_TIME"))
                              : dayjs(`2022-04-17T${selectedInTime}`)
                          }
                          // value={
                          //   watch("JOB_IN_TIME")
                          //     ? dayjs(`2022-01-01T${watch("JOB_IN_TIME")}`)
                          //     : null
                          // }
                          onChange={
                            (newTime) =>
                              setValue(
                                "JOB_IN_TIME",
                                dayjs(newTime).format("HH:mm") || null
                              )
                            // setSelectedInTime(dayjs(newTime).format('HH:mm'))
                          }
                        />
                      </DemoContainer>
                      {errors.JOB_IN_TIME && (
                        <Typography color="error" variant="body2" mt={1}>
                          {errors.JOB_IN_TIME.message}
                        </Typography>
                      )}
                    </Grid>
                    <Grid item xs={6}>
                      <DemoContainer components={["TimePicker"]}>
                        <MobileTimePicker
                          label="To"
                          // value={dayjs(`2022-04-17T${selectedInTime}`)}
                          value={
                            watch("JOB_OUT_TIME")
                              ? dayjs(watch("JOB_OUT_TIME"))
                              : dayjs(`2022-04-17T${selectedInTime}`)
                          }
                          // value={
                          //   watch("JOB_OUT_TIME")
                          //     ? dayjs(`2022-01-01T${watch("JOB_OUT_TIME")}`)
                          //     : null
                          // }
                          onChange={
                            (newTime) =>
                              setValue(
                                "JOB_OUT_TIME",
                                dayjs(newTime).format("HH:mm") || null
                              )
                            //  setSelectedOutTime(dayjs(newTime).format('HH:mm'))
                          }
                        />
                      </DemoContainer>

                      {errors.JOB_OUT_TIME && (
                        <Typography color="error" variant="body2" mt={1}>
                          {errors.JOB_OUT_TIME.message}
                        </Typography>
                      )}
                    </Grid>
                  </LocalizationProvider>
                </Grid>
              </>
            ) : (
              <>
                {jobData?.GENERATE_JOB_DATES === 1 && (
                  <>
                    <Grid item xs={12} sm={12}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={generateJobDates}
                            onChange={(e) => setGeneratedJobDates(e.target.checked)}
                            color="primary" // Change color if needed
                          />
                        }
                        label="Generate new job dates"
                      />
                      <Tooltip
                        title="You already generated the job date and days. If you want to change them, click on the checkbox 'Generate new job Dates'."
                        arrow
                        placement="top"
                      >
                        <IconButton size="small">
                          <InfoOutlinedIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ mt: 0 }}
                    >
                      Note: Job service dates have already been generated. If
                      you change the date or days, the existing service dates
                      will be removed. To proceed with changes, select the
                      "Generate new job dates" checkbox.
                    </Typography>
                  </>
                )}

                {showJobTypeSection && (
                  <>
                    <Grid item xs={12} sm={12}>
                      <Typography variant="h4" mt={2}>
                        How often?
                      </Typography>
                    </Grid>

                    <Grid item xs={9} sm={12} display={"flex"} gap={2} mt={2}>
                      <>
                        {list?.map((row, index) => (
                          <ChipRowTime
                            key={index}
                            row={row}
                            selectedChips={watch("JOB_SERVICE_DURATION")}
                            handleClick={(e) =>
                              setValue("JOB_SERVICE_DURATION", e)
                            }
                          />
                        ))}
                        <Chip
                          label="Bi-weekly"
                          variant="outlined"
                          onClick={() => {
                            showToast("error", "selection is disabled yet.");
                          }} // Pass ID to handleClick
                          color="default"
                          sx={{
                            backgroundColor: "transparent",
                            color: "inherit",
                          }}
                        />

                        {errors.JOB_SERVICE_DURATION && (
                          <Typography color="error" variant="body2" mt={1}>
                            {errors.JOB_SERVICE_DURATION.message}
                          </Typography>
                        )}
                      </>
                    </Grid>
                  </>
                )}

                <Grid
                  container
                  alignItems="center"
                  spacing={1}
                  justifyContent="space-around"
                  sx={{
                    pointerEvents:
                      !generateJobDates && jobData?.GENERATE_JOB_DATES === 1
                        ? "none"
                        : "auto",
                    cursor:
                      !generateJobDates && jobData?.GENERATE_JOB_DATES === 1
                        ? "not-allowed"
                        : "auto",
                  }}
                >
                  <Grid item xs={12} sm={12}>
                    <Typography variant="h4" mt={2}>
                      What's the Schedule?
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} display={"flex"} gap={2} mt={2}>
                    <>
                      {weeklist.map((row, index) => (
                        <ChipRowTime2
                          key={index}
                          row={row}
                          selectedChips={time}
                          handleClick={handleClick}
                        />
                      ))}
                    </>
                  </Grid>

                  <Grid item xs={12} sm={12} px={0.5}>
                    {errors.JOB_SERVICE_WITH_DAY_TIME && (
                      <Typography color="error" variant="body2" mt={1}>
                        {errors.JOB_SERVICE_WITH_DAY_TIME.message}
                      </Typography>
                    )}
                  </Grid>

                  <Grid item lg={12} xs={12} sm={12} px={0.5} mt={1}>
                    {time.length > 0 &&
                      time.map((val, i) => (
                        <Card
                          key={i}
                          style={{
                            background: "#f5f5f5",
                            marginBottom: 20,
                            width: "410px",
                          }}
                        >
                          <Grid
                            p={2}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography variant="h5">{val.JOB_DAY}</Typography>
                            <Grid display={"flex"}>
                              <Typography variant="h5">
                                {val.JOB_IN_TIME} -{val.JOB_OUT_TIME}
                              </Typography>
                              <ModeEditOutlineOutlinedIcon
                                sx={{
                                  paddingLeft: "5px",
                                  fontSize: "18px",
                                  cursor: "pointer",
                                  color:
                                    "linear-gradient(to right,#4eb3e8,#6ebe44)",
                                }}
                                onClick={() => {
                                  setOpenModal({ value: val, index: i });
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Card>
                      ))}
                  </Grid>
                </Grid>

                {jobDates.length > 0 && (
                  <Button variant="contained" onClick={handleShowJobDates}>
                    Show Job Details
                  </Button>
                )}
              </>
            )}
          {/* </Grid> */}

     <Grid
        item
        xs={12}
        sm={12}
        display="flex"
        alignItems="center"
        gap={1}
      >
        <Typography variant="h4"  mt={2}>Required Documents</Typography>
      </Grid>

      <Grid
      item
      xs={12}
      sm={12}
      display="flex"
      flexDirection="column"
      gap={1}
    >
      <Box display="flex" gap={1}>
        <FormControl fullWidth>
          <OutlinedInput
            placeholder="Type document name and press Enter"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
        </FormControl>

        <FormControlLabel
          control={
            <Checkbox
              checked={isRequired}
              onChange={(e) => setIsRequired(e.target.checked)}
            />
          }
          label="Required"
        />

        <Button
          variant="contained"
          color="primary"
          onClick={handleAdd}
          disabled={!inputValue.trim()}
        >
          Add
        </Button>
      </Box>

      {/* Render chips for each document */}
      <Box display="flex" flexWrap="wrap" gap={1}>
        {documentNames.map((doc, index) => (
          <Chip
            key={index}
            label={
              doc.DOCUMENT_NAME +
              (doc.IS_REQUIRED ? " (Required)" : "")
            }
            onDelete={() => handleDelete(doc.DOCUMENT_NAME)}
            color="primary"
            variant="outlined"
          />
        ))}
      </Box>
    </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            display={"flex"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant="h4" mt={2}>Positions Available</Typography>
            {""}
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            display={"flex"}
            alignItems={"center"}
            gap={1}
          >
            <FormControl fullWidth>
              <OutlinedInput
                {...register("REQUIRED_APPLICANTS")}
                value={watch("REQUIRED_APPLICANTS") || ""}
                onInput={(e) =>
                  (e.target.value = e.target.value.replace(/\D/, ""))
                } // Ensure only numbers are input
                type="number" // This restricts input to numbers only
              />
            </FormControl>
          </Grid>

        

          <Grid item xs={12} sm={12} alignItems={"center"} gap={1}>
            <Stack direction="row" spacing={0.5}>
              <LocationOnIcon
                sx={{ fontSize: "18px", color: "#6eBE44", paddingRight: 1 }}
              />
              <Typography variant="h4" sx={{ color: "#6ebe44" }}>
                Select the Facility{" "}
                <span style={{ color: "#000000" }}>Location</span>{" "}
              </Typography>
            </Stack>

            <Box px={2.6}>
              <Typography
                variant="h5"
                sx={{ fontSize: "14px", color: "#000000", opacity: "60%" }}
              >
                Choose or enter the facility where this job will be based{" "}
              </Typography>
            </Box>
          </Grid>

          <Grid item lg={12} xs={12} sm={6} onClick={() => setOpenModal1(true)}>
            <Card
              sx={{
                boxShadow: "none",
                background: "#d2ebd3",
                borderRadius: 0,
                margin: 0,
                marginTop: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: 1,
                }}
              >
                <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                  {locationData?.FACILITY_NAME || watch("FACILITY_LOCATION")}
                </Typography>
                {/* <ModeEditOutlineOutlinedIcon sx={{ fontSize: "18px", cursor: "pointer", color: "#6ebe44" }}
                                /> */}
                <VisibilityOutlinedIcon
                  sx={{
                    fontSize: "25px",
                    cursor: "pointer",
                    color: "#6ebe44",
                  }}
                  onClick={() => setOpenModal1(true)}
                />
              </Box>
              <Box
                mt={1}
                sx={{ display: "flex", alignItems: "center", padding: 1 }}
              >
                <LocationOnIcon
                  sx={{
                    fontSize: "18px",
                    color: "linear-gradient(to right,#4eb3e8,#6ebe44)",
                    paddingRight: 1,
                  }}
                />
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 400,
                    color: "#000000",
                    opacity: "60%",
                    wordBreak: "break-word",
                  }}
                >
                  {locationData?.STREET_ADDRESS || watch("FACILITY_LOCATION")}
                </Typography>
              </Box>
            </Card>
            {errors?.LOCATION?.message && (
              <FormHelperText error>{errors.LOCATION.message}</FormHelperText>
            )}
          </Grid>
          <Grid item xs={12} sm={12}>
            <Typography variant="h4" sx={{ fontWeight: 700 }} mt={2}>
              {/* What range would you like to pay for this job? */}
              Set the pay range for this job
            </Typography>
            <Typography variant="h5" sx={{ fontWeight: 600 }} mt={1}>
              {/* Average pay per hour */}
              Enter hourly rate
            </Typography>
          </Grid>
          <Grid item xs={6} sm={6}>
            <FormControl fullWidth error={!!errors?.PAY_AMOUNT_FROM}>
              <InputLabel htmlFor="outlined-adornment-amount">From</InputLabel>
              <OutlinedInput
                id="outlined-adornment-amount"
                startAdornment={
                  <InputAdornment position="start">$</InputAdornment>
                }
                label="From"
                {...register("PAY_AMOUNT_FROM")}
                value={watch("PAY_AMOUNT_FROM") || ""}
                error={!!errors?.PAY_AMOUNT_FROM}
                helperText={errors?.PAY_AMOUNT_FROM?.message}
              />
            </FormControl>
            {errors.PAY_AMOUNT_FROM && (
              <Typography color="error" variant="body2" mt={1}>
                {errors.PAY_AMOUNT_FROM.message}
              </Typography>
            )}
          </Grid>
          <Grid item xs={6} sm={6}>
            <FormControl fullWidth error={!!errors?.PAY_AMOUNT_TO}>
              <InputLabel htmlFor="outlined-adornment-amount">To</InputLabel>
              <OutlinedInput
                id="outlined-adornment-amount"
                startAdornment={
                  <InputAdornment position="start">$</InputAdornment>
                }
                label="To"
                {...register("PAY_AMOUNT_TO")}
                value={watch("PAY_AMOUNT_TO") || ""}
              />
            </FormControl>
            {errors.PAY_AMOUNT_TO && (
              <Typography color="error" variant="body2" mt={1}>
                {errors.PAY_AMOUNT_TO.message}
              </Typography>
            )}
          </Grid>
          <Grid
            item
            xs={12}
            mt={2}
            sm={6}
            md={12}
            lg={12}
            style={{ justifyContent: "end", display: "flex" }}
          >
            <Button className="custombuttons" type="submit">
              Next
            </Button>
          </Grid>
        </Grid>
        {openModal && (
          <Modal
            open={openModal}
            onClose={() => setOpenModal(false)}
            aria-labelledby="delete-modal-title"
            aria-describedby="delete-modal-description"
          >
            <Card sx={style}>
              <Box>
                <Typography
                  id="delete-modal-title"
                  sx={{ textAlign: "center" }}
                  variant="h4"
                  component="h2"
                >
                  Select Time
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["TimePicker"]}>
                    <MobileTimePicker
                      label="From"
                      value={dayjs(`2022-04-17T${selectedInTime}`)}
                      onChange={(newTime) =>
                        setSelectedInTime(dayjs(newTime).format("HH:mm"))
                      }
                    />
                  </DemoContainer>
                </LocalizationProvider>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["TimePicker"]}>
                    <MobileTimePicker
                      label="To"
                      value={dayjs(`2022-04-17T${selectedOutTime}`)}
                      onChange={(newTime) =>
                        setSelectedOutTime(dayjs(newTime).format("HH:mm"))
                      }
                    />
                  </DemoContainer>
                </LocalizationProvider>

                <Grid container mt={3} justifyContent={"center"} gap={2}>
                  <Button
                    variant="outlined"
                    color="secondary"
                    sx={{ width: "90px" }}
                    onClick={() => setOpenModal(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    sx={{ width: "90px" }}
                    onClick={handleSaveTime}
                  >
                    Save
                  </Button>
                </Grid>
              </Box>
            </Card>
          </Modal>
        )}

        {openJobDatesTable && (
          <JobDatesPopup
            open={openJobDatesTable}
            onClose={handleCloseJobDates}
            title="Job Details"
            rows={jobDates}
            columns={columns}
          />
        )}

        {openModal1 && (
          <Modal
            open={openModal1}
            onClose={() => setOpenModal1(false)}
            aria-labelledby="delete-modal-title"
            aria-describedby="delete-modal-description"
          >
            <Card sx={style}>
              {data?.OUTPUT.map((locationdata, i) => {
                return (
                  <>
                    <Card
                      sx={{
                        boxShadow: "none",
                        background: "#d2ebd3",
                        borderRadius: 0,
                        margin: 0,
                        marginTop: 2,
                      }}
                      onClick={() => {
                        // console.log("data?.OUTPUT[i]", data?.OUTPUT[i])
                        setLocationData(data?.OUTPUT[i]);
                        setOpenModal1(false);
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: 1,
                        }}
                      >
                        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                          {locationdata?.FACILITY_NAME}
                        </Typography>
                      </Box>
                      <Box
                        mt={1}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          padding: 1,
                        }}
                      >
                        <LocationOnIcon
                          sx={{
                            fontSize: "18px",
                            color: "#6eBE44",
                            paddingRight: 1,
                          }}
                        />
                        <Typography
                          sx={{
                            fontSize: "14px",
                            fontWeight: 400,
                            color: "#000000",
                            opacity: "60%",
                            wordBreak: "break-word",
                          }}
                        >
                          {locationdata?.STREET_ADDRESS}
                        </Typography>
                      </Box>
                    </Card>
                  </>
                );
              })}
            </Card>
          </Modal>
        )}
      </form>
    </>
  );
};

export default AddJobPrice;

